import React from 'react'
import { Typography } from '@mui/material'

import { dsColorNew } from '@palette'


// The line under a field; a long one is cut with "…" and says itself whole on hover (E7)
export function FieldNote({ children, tone = 'muted', title }) {
	return <Typography component="div" title={title ?? (typeof children === 'string' ? children : undefined)} sx={{
		fontSize: 12, color: tone === 'info' ? dsColorNew.noteInfo : dsColorNew.textMuted, mt: 0.75, ml: 1.5,
		overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
	}}>{children}</Typography>
}
